var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10C10 8.4467 11.2592 7.1875 12.8125 7.1875C14.3658 7.1875 15.625 8.4467 15.625 10C15.625 11.5533 14.3658 12.8125 12.8125 12.8125C11.2592 12.8125 10 11.5533 10 10Z",
    fill: "#1ABCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 15.625C4.375 14.0717 5.6342 12.8125 7.1875 12.8125H10V15.625C10 17.1783 8.7408 18.4375 7.1875 18.4375C5.6342 18.4375 4.375 17.1783 4.375 15.625Z",
    fill: "#0ACF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.5625V7.1875H12.8125C14.3658 7.1875 15.625 5.9283 15.625 4.375C15.625 2.8217 14.3658 1.5625 12.8125 1.5625H10Z",
    fill: "#FF7262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 4.375C4.375 5.9283 5.6342 7.1875 7.1875 7.1875H10V1.5625H7.1875C5.6342 1.5625 4.375 2.8217 4.375 4.375Z",
    fill: "#F24E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 10C4.375 11.5533 5.6342 12.8125 7.1875 12.8125H10V7.1875H7.1875C5.6342 7.1875 4.375 8.4467 4.375 10Z",
    fill: "#A259FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.745f460e20d7197f3823cdf6835c9ffd.svg";
export { ForwardRef as ReactComponent };